export const ICONS = {
  teacher: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/People/Woman%20Teacher.png",
  manTeacher: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/People/Man%20Teacher.png",
  notebook: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Notebook.png",
  pencil: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Pencil.png",
  folder: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/File%20Folder.png",
  phone: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Telephone%20Receiver.png",
  birthday: "/images/birthday_cake_animated.png",
  pin: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Pushpin.png",
  sparkles: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Travel%20and%20places/Sparkles.png",
  calendar: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Calendar.png",
  party: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Activities/Party%20Popper.png",
  prayer: "/images/prayer_3d.png",
  memo: "https://raw.githubusercontent.com/Tarikul-Islam-Anik/Animated-Fluent-Emojis/master/Emojis/Objects/Memo.png",
};

export const FAITH_STATE_STYLES = {
  "초신자": "bg-amber-400 text-white border-amber-400",
  "기존신자": "bg-[#354F38] text-white border-[#354F38]",
  "양육중": "bg-blue-500 text-white border-blue-500",
  "시험듦": "bg-rose-500 text-white border-rose-500",
  "장기결석": "bg-gray-400 text-white border-gray-400",
};

export const INITIAL_FORM_DATA = {
  name: "",
  gender: "남",
  role: "교사",
  charge: "",
  responsibility: "",
  phone: "",
  birth: "",
  address: "",
  notes: "",
  photoUrl: "",
  school: "",
  faithState: "기존신자",
};
